import { RootState } from '../../store';

export const selectInvoices = (state: RootState) => state.invoice.invoices.results;
export const selectInvoicesCount = (state: RootState) => state.invoice.invoices.count;

export const selectOrgInvoices = (state: RootState) => state.invoice.orgInvoices.results;
export const selectOrgInvoicesCount = (state: RootState) => state.invoice.orgInvoices.count;

export const selectInvoicesLoading = (state: RootState) => state.invoice.loading;
export const selectInvoicesError = (state: RootState) => state.invoice.error;

export const selectInvoiceDetails = (state: RootState) => state.invoice.invoiceDetails.data;
export const selectInvoiceDetailsLoading = (state: RootState) => state.invoice.invoiceDetails.loading;
export const selectInvoiceDetailsError = (state: RootState) => state.invoice.invoiceDetails.error;
